import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteNav } from "@/components/SiteNav";
import { SiteFooter } from "@/components/SiteFooter";

export const Route = createFileRoute("/datenschutz")({
  head: () => ({
    meta: [
      { title: "Datenschutz – Energie Prime 360" },
      { name: "description", content: "Datenschutzerklärung der Plattform Energie Prime 360." },
    ],
  }),
  component: DatenschutzPage,
});

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <>
      <h2 className="font-display text-2xl pt-6">{title}</h2>
      {children}
    </>
  );
}

function DatenschutzPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <SiteNav />
      <main className="mx-auto max-w-3xl px-6 md:px-10 py-20 md:py-28">
        <Link to="/" className="eyebrow text-[var(--leaf)] hover:underline">← Zurück</Link>
        <h1 className="font-display text-4xl md:text-5xl mt-6 mb-10">Datenschutzerklärung</h1>
        <div className="space-y-4 text-base leading-relaxed text-foreground/85">
          <Section title="1. Verantwortlicher">
            <p>Verantwortlicher für die Datenverarbeitung auf dieser Website ist:</p>
            <p>
              Christoph Bachmann<br />
              Thunemeiershof 41<br />
              33102 Paderborn<br />
              Deutschland<br /><br />
              E-Mail: [E-Mail-Adresse ergänzen]
            </p>
            <p>
              Die Website „Energie Prime 360" ist ein Angebot der Energie- &amp; Fördermittel
              Zentrum Deutschland GmbH.
            </p>
          </Section>
          <Section title="2. Allgemeine Hinweise zur Datenverarbeitung">
            <p>
              Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Wir behandeln Ihre
              personenbezogenen Daten vertraulich und entsprechend den gesetzlichen
              Datenschutzvorschriften sowie dieser Datenschutzerklärung.
            </p>
            <p>
              Personenbezogene Daten werden nur verarbeitet, soweit dies zur Bereitstellung der
              Website, zur Bearbeitung von Anfragen oder zur Erfüllung gesetzlicher Pflichten
              erforderlich ist.
            </p>
          </Section>
          <Section title="3. Erhebung und Speicherung personenbezogener Daten">
            <p>Beim Besuch dieser Website werden durch den Hosting-Anbieter automatisch Informationen erfasst:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>IP-Adresse</li>
              <li>Datum und Uhrzeit des Zugriffs</li>
              <li>Browsertyp und Browserversion</li>
              <li>Betriebssystem</li>
              <li>Referrer-URL</li>
              <li>aufgerufene Seiten</li>
            </ul>
            <p>Diese Daten dienen ausschließlich der technischen Bereitstellung und Sicherheit der Website.</p>
          </Section>
          <Section title="4. Kontaktformular und Anfragen">
            <p>
              Wenn Sie uns über ein Kontaktformular, per E-Mail oder telefonisch kontaktieren,
              werden die von Ihnen übermittelten Daten zur Bearbeitung Ihrer Anfrage gespeichert
              und verarbeitet.
            </p>
            <p>Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO sowie Art. 6 Abs. 1 lit. f DSGVO.</p>
          </Section>
          <Section title="5. Analyse- und Trackingdienste">
            <p>
              Soweit Analyse- oder Trackingdienste eingesetzt werden, erfolgt dies ausschließlich
              auf Grundlage Ihrer Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO.
            </p>
            <p>Vor der Aktivierung entsprechender Dienste wird Ihre Zustimmung über ein Consent-Management-System eingeholt.</p>
          </Section>
          <Section title="6. Cookies">
            <p>Diese Website verwendet technisch notwendige Cookies.</p>
            <p>Darüber hinausgehende Cookies für Analyse-, Marketing- oder Komfortfunktionen werden nur nach vorheriger Einwilligung gesetzt.</p>
          </Section>
          <Section title="7. Weitergabe von Daten">
            <p>Eine Weitergabe personenbezogener Daten an Dritte erfolgt ausschließlich:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>zur Vertragserfüllung,</li>
              <li>aufgrund gesetzlicher Verpflichtungen,</li>
              <li>auf Grundlage Ihrer Einwilligung,</li>
              <li>oder soweit dies zur Wahrung berechtigter Interessen erforderlich ist.</li>
            </ul>
            <p>Eine darüber hinausgehende Weitergabe erfolgt nicht.</p>
          </Section>
          <Section title="8. Speicherdauer">
            <p>
              Personenbezogene Daten werden nur so lange gespeichert, wie dies für die jeweiligen
              Zwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen.
            </p>
          </Section>
          <Section title="9. Rechte betroffener Personen">
            <p>Sie haben jederzeit das Recht auf:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Auskunft gemäß Art. 15 DSGVO</li>
              <li>Berichtigung gemäß Art. 16 DSGVO</li>
              <li>Löschung gemäß Art. 17 DSGVO</li>
              <li>Einschränkung der Verarbeitung gemäß Art. 18 DSGVO</li>
              <li>Datenübertragbarkeit gemäß Art. 20 DSGVO</li>
              <li>Widerspruch gemäß Art. 21 DSGVO</li>
            </ul>
            <p>Darüber hinaus besteht ein Beschwerderecht bei einer zuständigen Datenschutzaufsichtsbehörde.</p>
          </Section>
          <Section title="10. Datensicherheit">
            <p>
              Wir setzen angemessene technische und organisatorische Sicherheitsmaßnahmen ein, um
              personenbezogene Daten vor Verlust, Manipulation oder unberechtigtem Zugriff zu
              schützen.
            </p>
          </Section>
          <Section title="11. Datenschutzbeauftragter">
            <p>Soweit gesetzlich erforderlich, wurde ein Datenschutzbeauftragter bestellt.</p>
            <p>
              <strong>Datenschutzbeauftragter:</strong><br />
              Christoph Bachmann<br />
              Thunemeiershof 41<br />
              33102 Paderborn<br /><br />
              E-Mail: [E-Mail-Adresse ergänzen]
            </p>
          </Section>
          <Section title="12. Änderungen dieser Datenschutzerklärung">
            <p>
              Wir behalten uns vor, diese Datenschutzerklärung anzupassen, um sie an geänderte
              rechtliche Anforderungen oder technische Entwicklungen anzupassen.
            </p>
          </Section>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
